import { useQuery } from '@apollo/client';
import {
  GET_INVOICE_PROMOTION,
  GET_INVOICE_PROMOTION_PACKAGES,
  type InvoicePromotionPackagesResponse,
  type InvoicePromotionPackagesVariables,
  type InvoicePromotionResponse,
} from '../api';
import { getPromotionPackages } from '../PackagesSection.helpers';
import { useCurrentUser } from '@/features/Profile/core/hooks/useCurrentUser';

export function useInvoicePromotion(isEnabled: boolean) {
  const { isShop } = useCurrentUser();
  const isBrowser = typeof window !== 'undefined';
  const { data } = useQuery<InvoicePromotionResponse>(GET_INVOICE_PROMOTION, {
    skip: !isBrowser || !isEnabled || !isShop,
    fetchPolicy: 'cache-and-network',
  });

  return {
    promotion: data?.invoicePromotion ?? null,
  };
}

export function useInvoicePromotionPackages(isDetailsOpen: boolean) {
  const { isShop, shop } = useCurrentUser();
  const segment = shop?.segment?.toUpperCase();
  const isBrowser = typeof window !== 'undefined';
  const { data, loading } = useQuery<
    InvoicePromotionPackagesResponse,
    InvoicePromotionPackagesVariables
  >(GET_INVOICE_PROMOTION_PACKAGES, {
    variables: segment ? { segment } : undefined,
    skip: !isBrowser || !isDetailsOpen || !isShop || !segment,
    fetchPolicy: 'cache-first',
  });

  return {
    isPackagesLoading: isDetailsOpen && loading,
    promotionPackages: getPromotionPackages(data),
  };
}
